import { z } from "zod";
import { AddressSchema } from "@/types/schemas/addresses";
import { PhoneSchema } from "@/types/schemas/phone";

export const ContactSchema = z
  .object({
    $schema: z.string().optional(),
    primary_phone: PhoneSchema,
    primary_address: AddressSchema,
    primary_email: z.string().email(),
    other: z
      .array(
        z.object({
          phone: PhoneSchema.optional(),
          address: AddressSchema.optional(),
          email: z.string().email(),
        }),
      )
      .optional(),
  })
  .default({
    primary_phone: {
      country_code: 1,
      area_code: 405,
      phone: 5555555,
    },
    primary_email: "sample@email.com",
    primary_address: {
      type: "house",
      street: "124",
      city: "Maple",
      state: "NY",
      zip: "55555",
    },
    other: [],
  });
